import { useUserContext } from '../../../../contexts/UserContext';

import { VerifyTooltip } from '../../../../components/PageWrappers/SharedComponents/VerifyTooltip/VerifyTooltip';
import { Button } from '../../../../components/Toolkit/Button/Button';

import type { RevealDealerEnquiryModalProps } from '../../../../components/PageWrappers/SharedComponents/RevealDealerEnquiryModal/RevealDealerEnquiryModal.typed';

function RevealDealerEnquiryModal(props: RevealDealerEnquiryModalProps) {
  const {
    size = 'SMALL',
    testId,
    trackingId,
    text = 'Make an Enquiry',
    disabled = false,
    id,
    ofType = 'PRIMARY',
    handleReveal,
  } = props;
  const { user } = useUserContext();

  const userIsNotMinimumVerified = Boolean(user && !user.isMinimumVerified);

  return (
    <>
      {userIsNotMinimumVerified ? (
        <VerifyTooltip
          arrowPosition={['right', 'right', 'center']}
          tooltipPosition={'above'}
        >
          <Button
            size={size}
            data-testid={testId}
            data-tracking={trackingId}
            disabled={disabled}
            id={id}
            ofType={ofType}
          >
            {text}
          </Button>
        </VerifyTooltip>
      ) : (
        <Button
          size={size}
          onClick={() => handleReveal(id)}
          data-testid={testId}
          data-tracking={trackingId}
          disabled={disabled}
          id={id}
          ofType={ofType}
        >
          {text}
        </Button>
      )}
    </>
  );
}

export { RevealDealerEnquiryModal };
